import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GridOnIcon(props: IconProps) {
    return <Icon {...props} iconKey={"grid_on"}/>
}
